(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-review-slider"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-review-slider')) {
    customElements.define(
      'product-review-slider',
      class ProductReviewSlider extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-track]');
          this.dots = [...this.querySelectorAll('[data-dot]')];
          this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index)));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
        }

        go(index) {
          const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
          this.track.scrollTo({ left: index * this.track.clientWidth, behavior });
        }

        // Marca el punto de la reseña visible, también al deslizar con el dedo
        update() {
          const current = Math.round(this.track.scrollLeft / this.track.clientWidth);
          this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
